import React from 'react';
import { Link } from 'react-router-dom';
import { INDEX_URL } from '~/data/constants/router-constants';

const Branding = () => (
	<Link className="branding__link" to={INDEX_URL} aria-label="Go to the Homepage">
		<svg className="branding__large" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 226 48">
			<path
				className="branding__lettering"
				d="M147 9.87h5.59v10.05H163V9.87h5.6v25.44H163V25.09h-10.38v10.22H147zM172.41 9.87H178v25.44h-5.6zM181.89 9.87h5.6v20.35h12.69v5.09h-18.29zM202.57 9.87h9.92c8 0 13.51 5.49 13.51 12.64v.08c0 7.14-5.52 12.72-13.51 12.72h-9.92zm9.92 20.38a7.26 7.26 0 0 0 7.67-7.58v-.08a7.31 7.31 0 0 0-7.67-7.67h-4.32v15.33zM136.29 14.6a7.73 7.73 0 0 1 6.79 4.07V11.2a14 14 0 0 0-6.79-1.77 13.1 13.1 0 0 0-13 10.52l5.44 13.51a13.43 13.43 0 0 0 7.58 2.28 13.9 13.9 0 0 0 6.77-1.74v-7.47a7.77 7.77 0 0 1-6.79 4.07 8 8 0 0 1 0-16z"
				fill="#fff"
			/>
			<path
				className="branding__logo"
				fill="#fff"
				d="M89.08 41l1.5-8.64H96l-2.3 13.52zm5.14-29.3l-2.31 13.1h5.46l4-22.74h-6.22L76 27.45l3.75 3.91h19.6l1-5.46H83.54zm17.53-9.6h-6.25l-7.61 43.8 6.3-4.83 5.17-29.41L119 35.55h-1.6l-3.84-9.65h-5.68l-1 5.46h2.58l3.89 9.64h14.08z"
				data-name="4a"
			/>
			<path
				className="branding__lettering"
				d="M0 9.87h11.63c3.24 0 5.74.9 7.42 2.58a8 8 0 0 1 2.17 5.82v.08a7.9 7.9 0 0 1-5.46 7.88L22 35.31h-6.54L10 27.18H5.6v8.15H0zm11.28 12.36c2.72 0 4.29-1.44 4.29-3.58v-.09c0-2.39-1.68-3.64-4.4-3.64H5.6v7.31zM24.08 24.41V9.87h5.6v14.4c0 4.13 2.06 6.28 5.49 6.28s5.49-2.07 5.49-6.12V9.87h5.59v14.35c0 7.69-4.32 11.49-11.14 11.49s-11.03-3.8-11.03-11.3zM50.11 9.87h5.17l11.93 15.68V9.87h5.51v25.44H68L55.66 19.14v16.17h-5.52V9.87z"
				fill="#fff"
			/>
		</svg>
		<svg xmlns="http://www.w3.org/2000/svg" className="branding__small" viewBox="0 0 58 48">
			<path
				fill="#fff"
				d="M15.15 42.67l1.64-9.47h6L20.22 48zm5.63-32.1l-2.53 14.35h6L28.64 0h-6.85L.83 27.78l4.11 4.29h21.47l1-6H9.08zM40 0h-6.86L24.8 48l6.91-5.3 5.66-32.22 10.54 26.18h-1.76L42 26.08h-6.27l-1 6h2.83l4.22 10.57h15.39z"
				data-name="4a"
			/>
		</svg>
	</Link>
);

export default Branding;



// WEBPACK FOOTER //
// ./src/components/general/branding/index.jsx